// extracted by mini-css-extract-plugin
export default {"container":"Tabs_container__vdVkU","tab_item":"Tabs_tab_item__H3U2V"};